// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"vz_a bgu_b","TwoDimsListFeature__item":"vz_b bgu_ux","TwoDimsListFeature__item__text":"vz_c bgu_un"};